import { BackHandler, Keyboard, Platform, Pressable, StatusBar, Text, View } from "react-native";
import React, { useCallback, useEffect, useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";


import { autoVerify, registerPhone, verifyPhone } from "../../../services/Auth/authService";
import { styles } from "../auth.style";
import AuthIcons from "../../../assets/Icons/AuthIcons";
import TopIconView from "../components/TopIconView";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";
import OTPInputWeb from "../components/OTPInputWeb";
import OTPInputMobile from "../components/OTPInputMobile";


export default function OtpAuth({
  route,
  navigation,
  alreadyRegistered,
}: {
  route: any;
  navigation: any;
  alreadyRegistered?: boolean;
}) {
  const { number, countryCode } = route.params;
  const [otpError, setOtpError] = useState(false);
  const [otpCode, setOTPCode] = useState("");
  const [resendCountdown, setResendCountdown] = useState(60);

  const length = 6;

  const intervalCallback = useCallback(() => {
    setResendCountdown((prevCountdown) => prevCountdown - 1);
  }, []);

  // useEffect for handling the countdown
  useEffect(() => {
    let countdownInterval: NodeJS.Timeout;

    if (resendCountdown > 0) {
      countdownInterval = setInterval(intervalCallback, 1000);
    }

    return () => {
      clearInterval(countdownInterval);
    };
  }, [resendCountdown, intervalCallback]);

  // if press back
  useEffect(() => {
    function handleBackButton() {
      BackHandler.exitApp();
      return true;
    }
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackButton
    );
    return () => backHandler.remove();
  }, [navigation]);

  const formatCountdown = () => {
    const minutes = Math.floor(resendCountdown / 60);
    const seconds = resendCountdown % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  // --------- developement OTP verification --------

  // const handleVerifyOTP = async () => {
  //   // api call to send number to backend
  //   const payload = {
  //     phoneNumber: number,
  //     countryCode: '+91',
  //     email: route.params.email
  //   };
  //   try {
  //     const response = await autoVerify(payload)
  //     if (response?.data?.accessToken.accessTokenJWT) {
  //       navigation.navigate("auth-success", {
  //         accessToken: response?.data?.accessToken.accessTokenJWT,
  //         refreshToken: response?.data?.refreshToken.refreshTokenJWT
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error during API call:", (error as Error).message);
  //     // Handle the error as needed
  //   }
  // };

  // --------- production ready OTP for OTP verification --------

  const handleVerifyOTP = async () => {
    // api call to send number to backen
    let payload: any;
    if (route?.params?.email) {
      payload = {
        countryCode: route?.params?.countryCode?.code,
        phone: number,
        otp: Array.isArray(otpCode) ? otpCode.join('') : otpCode,
        email: route?.params?.email
      };
    } else {
      payload = {
        countryCode: route?.params?.countryCode?.code,
        phone: number,
        otp: Array.isArray(otpCode) ? otpCode.join('') : otpCode
      };
    }
    try {
      const response = await verifyPhone(payload)
      console.log(response)
      if (response?.data) {
        navigation.navigate("auth-success", {
          accessToken: response?.data?.accessToken.accessTokenJWT,
          refreshToken: response?.data?.refreshToken.refreshTokenJWT
        });
        setOTPCode("");
        setResendCountdown(0);
      }else if(response?.error == "Invalid OTP!"){
        setOtpError(true)
      }else {
        // Handle other response cases if needed
      }
    } catch (error) {
      console.error("Error during API call:", (error as Error).message);
      // Handle the error as needed
    }
  };

  const handleResendOTP = async () => {
    try {
      await registerPhone({
        phone: number,
        countryCode: countryCode.code,
      });
      setResendCountdown(60);
    } catch (error) {
      console.error("Error in handleResendOTP:", error);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <Pressable style={{flex: 1}} onPress={Keyboard.dismiss}>
        <View style={styles.mobileAuthView}>
          <TopIconView icon={<AuthIcons.PasswordIcon />} password={true} />
          <CustomComponent.TextView
            title="Verify your number"
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                lineHeight: 37,
                letterSpacing: -0.3,
              },
            ]}
          />
          <View>
            <Text onPress={() => navigation.goBack()} style={[
                GlobalStyles.bodyText,
                {
                  color: "#ACABAB",
                  fontSize: 16,
                  fontFamily: "InterMedium",
                  opacity: 0.8,
                  lineHeight: 22,
                  letterSpacing: -0.3,
                  marginBottom: 14,
                },
              ]}>
              We have sent the OTP to your phone number{" "}
              <Text
                style={{
                  color: "#3e3e3e",
                  textDecorationLine: "underline",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center"
                }}
              >
                {number}
                <AuthIcons.EditIcon />
              </Text>
            </Text>
          </View>
          {
            Platform.OS === 'web' ? (
              <OTPInputWeb
                code={otpCode}
                setCode={setOTPCode}
                maximumLength={length}
                onOtpCompleted={handleVerifyOTP}
                error={otpError}
                errorTitle='Incorrect OTP'
              />
            ):(
              <OTPInputMobile
                setCode={setOTPCode}
                maximumLength={length}
                onOtpCompleted={handleVerifyOTP}
                error={otpError}
                errorTitle='Incorrect OTP'
                handleError={setOtpError}
              />
            )
          }
          {resendCountdown > 0 ? (
            <View style={{
              flexDirection:'row',
              alignItems: 'center'
            }}>
              <CustomComponent.TextView title="Resend in " textStyle={{opacity: 0.4}} />
              <CustomComponent.TextView
                title={`${formatCountdown()}`}
              />
            </View>
            
          ) : (
            <Pressable
              onPress={handleResendOTP}
              style={{
                flexDirection: "row",
                alignItems: "center",
                position: "relative",
              }}
            >
              <AuthIcons.ResendIcon />
              <Text>Resend OTP</Text>
            </Pressable>
          )}
        </View>
      </Pressable>
    </SafeAreaView>
  );
}
